import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import PdfUpload from "../service/pdfUpload3";
import "../css/pdf.css";
import "../css/Dialog.css";
import "../css/GPTApp.css";

function PdfUploadModal({
    PdfUploadModalVisible,
    onConfirm,
    onCancel,
    userID,
    projectName,
    basePath,
}) {
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]); // [{ name, relativePath, storagePath }]
    const [progress, setProgress] = useState({
        percent: 0,
        uploadedCount: 0,
        totalCount: 0,
        totalBytes: 0,
        transferredBytes: 0,
        files: [],
    });

    const handleFilesUploaded = (items) => setUploadedFiles(items || []);
    const prettyBytes = (n) => {
        if (!Number.isFinite(n)) return '0 B';
        const k = 1024, sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(Math.max(n, 1)) / Math.log(k));
        return `${(n / Math.pow(k, i)).toFixed(i ? 1 : 0)} ${sizes[i]}`;
    };

    const resetState = () => {
        setUploadedFiles([]);
        setProgress({
            percent: 0,
            uploadedCount: 0,
            totalCount: 0,
            totalBytes: 0,
            transferredBytes: 0,
            files: [],
        });
    };

    return (
        <Modal
            show={PdfUploadModalVisible}
            scrollable={true}
            className="modalPDF"
            backdrop="static"
            dialogClassName="modalPDF-dialog"
            onHide={onCancel}
        >
            <Modal.Header className="modalHeader">
                <Modal.Title className="modalTitle">
                    <span>File Uploader</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="modalBody">
                <div className="upContainer">
                    <div className="pdfUploadTitle">
                        {projectName ? (
                            <p>
                                Upload PDF file(s) in{" "}
                                <span className="project">{projectName.toUpperCase()}</span>{" "}
                                folder
                            </p>
                        ) : (
                            "Please select a Contract"
                        )}
                    </div>

                    {/* Dropzone (no inline progress inside) */}
                    <PdfUpload
                        userID={userID}
                        projectName={projectName}
                        basePath={basePath}
                        onFilesUploaded={handleFilesUploaded}
                        onStartLoading={() => {
                            resetState();
                            setLoadingFiles(true);
                        }}
                        onFinishLoading={() => setLoadingFiles(false)}
                        onProgress={(p) => setProgress(p)}
                        maxFiles={1000}
                    />

                    {/* Progress UI lives HERE */}
                    <div className="loadFileContainer" style={{ marginTop: 12 }}>
                        {loadingFiles && (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 10 }}>
                                    <div>
                                        {progress.uploadedCount} / {progress.totalCount} file(s) -
                                    </div>
                                    <div style={{ marginLeft: 12 }}>
                                        {prettyBytes(progress.transferredBytes)} / {prettyBytes(progress.totalBytes)}
                                    </div>
                                </div>

                                {/* Overall progress bar with orange color */}
                                <div style={{ height: 12, background: '#eee', borderRadius: 6 }}>
                                    <div
                                        style={{
                                            height: 12,
                                            width: `${progress.percent || 0}%`,
                                            background: 'var(--orange)',   
                                            borderRadius: 6,
                                            transition: 'width .2s ease',
                                        }}
                                    />
                                </div>

                            </div>
                        )}

                        {!loadingFiles && uploadedFiles.length > 0 && (
                            <div>
                                <p>{uploadedFiles.length} file(s) successfully uploaded!</p>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="modalFooter">
                <Button className="cancelButton" variant="dark" onClick={() => { onCancel(); resetState(); }} disabled={loadingFiles}>
                    Cancel
                </Button>
                <Button
                    className="confirmButtonPDF"
                    variant="dark"
                    onClick={() => {
                        onConfirm && onConfirm();
                        resetState();
                    }}
                    disabled={loadingFiles}
                >
                    Done
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PdfUploadModal;
